<template>
  <div>
    <el-checkbox-group v-model="ssxcheckList" @change="ssxChange">
      <el-checkbox label="省" border></el-checkbox>
      <el-checkbox label="市" border></el-checkbox>
      <el-checkbox label="县" border></el-checkbox>
    </el-checkbox-group>
  </div>
</template>
<script>
  import {
    initRegion,
    getRegion
  } from '@/api/api.js'
  export default {
    props: [],
    data() {
      return {
        ssxcheckList: [],
      }
    },
    mounted() {
    },
    computed: {
      nowxingzhengCodes() {
        return this.$store.state.nowxingzhengCode; //需要监听的数据
      },
    },
    watch: {
    },
    methods: {
      ssxChange() {
        this.$store.commit('ssxdataFun', this.ssxcheckList); //token
      },
    },
  }
</script>

<style scoped>
  >>>.el-input--suffix .el-input__inner {
    color: #fff !important;
    background: transparent;
    //border: 1px solid #00B3FE;
    //background-color: rgba(9, 34, 72, 0.5);
  }

  >>>.el-switch__label {
    color: #fff;
    height: 30px;
    line-height: 30px;
  }

  >>>.el-switch__label.is-active {
    color: #409EFF;
  }

  >>>.el-checkbox.is-bordered {
    height: 30px;
    width: 55px;
    line-height: 25px;
    margin: 0;
    padding: 2px;
    padding-left: 5px;
    border: 1px #00B3FE solid;
    background-color: rgba(9, 34, 72, 0.5);
  }

  >>>.el-checkbox__inner {
    background-color: transparent;
    border: 1px #00B3FE solid;
  }

  >>>.el-checkbox__label {
    color: #fff;
    font-size: 16px;
  }
</style>
